import React from 'react';
import PropTypes from 'prop-types';

const FieldHockeyPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M12.066 21.763a3.586 3.586 0 1 0 .002 7.172 3.586 3.586 0 0 0-.002-7.172zm0-1.355a4.935 4.935 0 0 1 4.937 4.936 4.935 4.935 0 0 1-4.937 4.937 4.935 4.935 0 0 1-4.936-4.937 4.935 4.935 0 0 1 4.936-4.936zm13.918-5.833c2.132 0 3.016 2.2 3.016 4.333s-.4 6.479-4.813 8.229c-.612.204-3.11 1.38-6.037.433.038-.654.072-.888.255-1.924.96.378 1.627.272 3.088.148 5.782-.48 5.914-5.161 5.837-7.63-.076-2.472-2.995-2.247-3.143-.45-.128 1.534-.485 5.387-3.59 5.387-2.146 0-2.919-1.232-3.59-2.243-.361-.544-2.358-3.53-4.223-6.364l-1.368 2.46c.57.998.807 1.257 1.215 1.954-.28-.043-.08-.017-.964 0-.527.013-.612 0-.965 0-3.487-6.024-7.285-13.65-7.612-14.21-.672-1.16 2.62-3.74 3.594-2.244 1.155 1.784 10.676 15.85 11.67 17.507 1.121 1.874 4.04 1.912 4.04-.896s1.457-4.49 3.59-4.49zm-17.958-3.59s.71-2.991 1.347-1.797c.089.17.297.51.582.96l-1.058 2.379c-.518-.926-.87-1.542-.87-1.542zm2.609 4.6l-.91-1.6 1.1-2.478c.34.527.723 1.11 1.122 1.72l-1.312 2.359z"
    />
  );
};

FieldHockeyPath.propTypes = {
  fill: PropTypes.string,
};

export default FieldHockeyPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/sports/field-hockey.jsx